export default "__VITE_ASSET__wl1H8zjh__"